import React from 'react';
import Menu from '../menu';
import ConditionalWrapper from '../conditional-wrapper';
import { PopoverContent, PopoverPortal } from '../popover';
import { useDropdownContext } from './dropdown-context';
import { usePopoverProvider } from '../popover/popover-context';
const DROPDOWN_MENU_NAME = 'vulcanui-dropdown-menu';
function DropdownMenu(props) {
    const { children } = props;
    const { portal = true } = useDropdownContext('DropdownMenu');
    const { isMounted } = usePopoverProvider('DropdownMenu');
    if (!isMounted)
        return null;
    return (React.createElement(ConditionalWrapper, { condition: portal, wrapper: (content) => React.createElement(PopoverPortal, null, content) },
        React.createElement(PopoverContent, null,
            React.createElement(Menu, null, children))));
}
DropdownMenu.displayName = 'Dropdown.Menu';
DropdownMenu.toString = () => `.${DROPDOWN_MENU_NAME}`;
export default DropdownMenu;
//# sourceMappingURL=dropdown-menu.js.map